module.exports = __webpack_public_path__ + "media/images/download-195b4defc7db1347c67aa0d6510f74f2.svg";